var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-agreement__bloc"},[_c('p',[_vm._v(" SVENSON店舗において、顧客IDをご発行済のお客様は、各規約をご確認いただき、 アカウント作成をお願いいたします。 ")]),_c('h4',[_vm._v("下記各規約をご確認いただき、規約に同意の上、会員登録へお進みください。")]),_c('terms'),_c('h4',[_vm._v("会員管理において、hubsynch株式会社が提供する「hubsynch」を利用します。")]),_c('hub-synch-terms')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }